import { Component, input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { StingrayAuthenticationService } from '@app/core/authentication/stingray-authentication.service';
import { BusinessUnit } from '@app/core/stingray-api/models';
import { OrganizationsService } from '@app/core/stingray-api/services';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';


@Component({
    selector: 'unite-businessunit-input',
    templateUrl: './businessunit-input.component.html',
    styleUrls: ['./businessunit-input.component.scss'],
    imports: [MatFormField, MatLabel, TranslateModule, MatSelect, ReactiveFormsModule, MatOption]
})
export class BusinessUnitInputComponent implements OnInit {

  control = input<FormControl>();

  businessUnits: BusinessUnit[] = [];

  constructor(private stingrayAuthenticationService: StingrayAuthenticationService) { }

  ngOnInit(): void {
    this.businessUnits = this.stingrayAuthenticationService.organization.businessUnits;
  }
}
